module.exports = {
  message: {
    select_region: "Seleccionar Región",
    europe: "Europa",
    america: "Américas",
    region_tip:
      "Nota: Los datos de los personajes no se comparten entre regiones.",
    confirm_select: "Confirmar",
    navigator_website: "Sitio Web",
    navigator_collect: "Coleccionar",
    navigator_service: "SC",
    navigator_teach: "Guía",
    navigator_logout: "Salir",
    navigator_mobile_logout: "iniciar sesión con móvil",
    navigator_email_logout: "Email",
    navigator_download: "Descargar",
    navigator_signIn: "Registrar",
    navigator_lang: "iniciar sesión",
    navigator_email: "Email",
    input_account: "Introduzca cuenta",
    input_mobile: "Introduzca el número de teléfono",
    input_password: "Introduzca la contraseña",
    input_password_again: "Confirme la contraseña",
    input_email_address: "Introduzca Email",
    input_reset_email:
      "Introduzca la cuenta/Email de la que deseas restablecer la contraseña",
    input_reset_password:
      ",restablecer contraseña mediante los siguientes métodos de verificación",
    retrieve_password: "Recuperar contraseña",
    forget_password: "Olvidar contraseña",
    next_step: "Siguiente",
    bind_email: "Vincular Email",
    input_bind_email: "Introduzca la cuenta de Email vinculada",
    bound_email: "Email vinculada ",
    enter_code: "Código de verificación",
    get_code: "obtener Código",
    get_code_seconds: "s",
    security_verification: "Verificación de securidad",
    inputTheAnswer: "Introduzca el Código de verificación",
    noneSelectArea: "Seleccionar el Código de Área",
    confirm: "Confirmar",
    bind: "Vincular",
    agree: "Leer y aceptar",
    tips_1:
      "El número no registrado se registrará e iniciará sesión tras la verificación",
    copy_success: "¡Copia correctamente!",
    copy_fail: "Copie manualmente,por favor",
    incorrect_email: "¡Introduzca la dirección de Email correcta,por favor!",
    emailTips1:
      "¡La contraseña no puede contener espacio ni caracteres chinos!",
    emailTips2: "La contraseña debe contener al menos 6 dígitos",
    emailTips3: "Las dos contraseñas que introduciste no coinciden",
    emailTips4: "Código de verificación incorrecto",
    emailTips5:
      "introduzca un nombre de cuenta de4 a 12 caracteres,combinando letras y números",
    emailTips6:
      "Introduzca una contraseña de 6~20 caracteres,combinando letras, números y caracteres especiales (sin caracteres chinos).",
    emailTips7: "Las dos contraseñas que introduciste no coinciden",
    selectAreaCode: "Código de área",
    urlError: "¡La dirección de acceso actual es incorrecta!",
    ThreeTips: "Consejo",
    verifiedTips1:
      "usuarios deben tener al menos 18 años para acceder a este juego",
    verifiedTips2:
      "Inicio de sesión fallido, por favor completa la verificación de identidad para jugar",
    rules_clause: "Condiciones de uso",
    privacy_clause: "Política de privacidad",
    service_email: "Email de Servicio al cliente",
    infoTitle: "Tutorial de inicio de sesión y recarga en PC",
    EmailAddress: "maplestoryr.na@gmail.com",
    selectAgeRange: "Por favor, seleccione un rango de edad.",
    payFailed: "Recarga fallida​",
    payFailedMessage:
      "Superado el límite de recarga mensual, no se puede recargar.",
    ageConfirm: "Verificación de Edad",
    limitTip:
      "El límite de recarga mensual depende del rango elegido; para modificarlo, contacte a la consulta.",
    age13: "Menor de 13 años/Recarga prohibida",
    age14_17: "​​14-17 años/Límite de recarga: 138 $/mes​",
    age18: "18 años o más/Sin límites de recarga​",
  },
};
